import { firebase, database } from "./firebase";
import { snapshot2List } from "./utils";

export const ordersTable = "orders";
const ordersRef = database.ref(ordersTable);

export function sendOrder(order) {
  order.time = new Date().toISOString().split("T")[0];
  const key = ordersRef.push().key;
  return ordersRef.child(key).set(order);
}

export function getOrders() {
  return new Promise((success, fail) => {
    ordersRef.orderByChild("time").once(
      "value",
      (snapshot) => {
        const list = snapshot2List(snapshot);
        list.reverse();
        success(list);
      },
      fail
    );
  });
}
